import type { settings as EN } from '../en/settings';

export const settings: Record<keyof typeof EN, string> = {
  'settings.title': 'Einstellungen',
  'settings.section.ai': 'KI',
  'settings.section.appearance': 'Darstellung',
  'settings.section.calendar': 'Kalender',
  'settings.section.data': 'Daten',
  'settings.appearance.theme': 'Design',
  'settings.appearance.density': 'Dichte',
  'settings.appearance.language': 'Sprache',
  'settings.appearance.language.hint': 'Die Sprache der Oberfläche und der KI-Antworten.',
  'settings.appearance.language.en': 'English',
  'settings.appearance.language.de': 'Deutsch',

  'settings.saving': 'Speichert…',

  'settings.ai.model.label': 'Modell',
  'settings.ai.model.hint': 'Wird bei der Erstellung einer Unterhaltung festgeschrieben.',
  'settings.ai.maxTokens.label': 'Maximale Antwortlänge (Tokens)',
  'settings.ai.maxTokens.hint': 'Wie lang Claudes Antwort ausfallen darf.',
  'settings.ai.thinking.label': 'Erweitertes Denken',
  'settings.ai.thinking.hint':
    'Lässt das Modell nachdenken, bevor es antwortet. Langsamer, aber besser bei schwierigen Fragen.',
  'settings.ai.prompt.label': 'Standard-Systemprompt',
  'settings.ai.prompt.hint': 'Bei einer neuen Unterhaltung vorausgewählt.',
  'settings.ai.prompt.none': '(keiner)',
  'settings.ai.prompt.libraryDefault': ' · Standard der Bibliothek',
  'settings.ai.prompt.manageLibrary': 'Prompt-Bibliothek verwalten',
  'settings.ai.contextBudget.label': 'Kontextbudget',
  'settings.ai.contextBudget.hint':
    'Maximale Anzahl Tokens an angehängtem Seiteninhalt, die mit jeder Nachricht gesendet werden.',

  'settings.appearance.theme.system': 'System',
  'settings.appearance.theme.light': 'Hell',
  'settings.appearance.theme.dark': 'Dunkel',
  'settings.appearance.density.hint':
    'Wie viel auf den Bildschirm passt. Kompakt ist die Standardeinstellung.',
  'settings.appearance.density.compact': 'Kompakt',
  'settings.appearance.density.comfortable': 'Komfortabel',
  'settings.appearance.density.previewRow': 'Eine Zeile der Seitenleiste, in dieser Dichte',

  'settings.calendar.weekStart.label': 'Woche beginnt am',
  'settings.calendar.weekStart.monday': 'Montag',
  'settings.calendar.weekStart.tuesday': 'Dienstag',
  'settings.calendar.weekStart.wednesday': 'Mittwoch',
  'settings.calendar.weekStart.thursday': 'Donnerstag',
  'settings.calendar.weekStart.friday': 'Freitag',
  'settings.calendar.weekStart.saturday': 'Samstag',
  'settings.calendar.weekStart.sunday': 'Sonntag',
  'settings.calendar.timezone.label': 'Zeitzone',
  'settings.calendar.timezone.hint':
    'Jedes Ereignis wird als Zeitpunkt gespeichert und in dieser Zeitzone angezeigt.',
  'settings.calendar.categories.label': 'Ereigniskategorien',
  'settings.calendar.categories.hint': 'Ein Name und eine Farbe. Keine Einstellung — CRUD.',

  'settings.data.description':
    'Keine Einstellungen — Verweise und die eine destruktive Aktion. Sie steht hier, weil man hier danach sucht.',
  'settings.data.backup.label': 'Sicherung',
  'settings.data.backup.hint': 'Es gibt bewusst keinen Export in der App.',
  'settings.data.backup.bodyPrefix': 'Eine Sicherung besteht aus zwei Teilen: einem Postgres-Dump ',
  'settings.data.backup.bodyAnd': 'und',
  'settings.data.backup.bodySuffix':
    ' dem Upload-Volume. Wird nur der Dump wiederhergestellt, sind alle Bilder defekt.',
  'settings.data.storage.label': 'Belegter Speicher',
  'settings.data.storage.loading': '…',
  'settings.data.storage.pages.one': '{count} Seite',
  'settings.data.storage.pages.other': '{count} Seiten',
  'settings.data.storage.trashed': ' ({count} im Papierkorb)',
  'settings.data.storage.images.one': '{count} Bild',
  'settings.data.storage.images.other': '{count} Bilder',

  'settings.dangerZone.title': 'Gefahrenzone',
  'settings.dangerZone.emptyTrash.label': 'Papierkorb leeren',
  'settings.dangerZone.emptyTrash.description':
    'Löscht endgültig jede archivierte Seite und alles darunter und entfernt die Bilder, die nur diese Seiten verwendet haben. Unwiderruflich.',
  'settings.dangerZone.emptyTrash.button': 'Papierkorb leeren ({count})',

  'settings.categories.empty':
    'Noch keine Kategorien. Ereignisse ohne Kategorie funktionieren trotzdem — sie sind einfach farblos.',
  'settings.categories.colorOf': 'Farbe von {name}',
  'settings.categories.nameOf': 'Name von {name}',
  'settings.categories.deleteOf': '{name} löschen',
  'settings.categories.deleteDialog.title': 'Die Kategorie „{name}“ löschen?',
  'settings.categories.deleteDialog.descriptionPrefix': 'Die Ereignisse darin werden ',
  'settings.categories.deleteDialog.descriptionNot': 'nicht',
  'settings.categories.deleteDialog.descriptionSuffix':
    ' gelöscht — sie verlieren nur ihre Kategorie und ihre Farbe. Du kannst sie danach einer anderen zuordnen.',
  'settings.categories.deleteDialog.confirm': 'Kategorie löschen',
  'settings.categories.colorOfNew': 'Farbe der neuen Kategorie',
  'settings.categories.newNameLabel': 'Name der neuen Kategorie',
  'settings.categories.newNamePlaceholder': 'Sitzung, Quest, Frist…',
  'settings.categories.save': 'Kategorie speichern',
  'settings.categories.add': 'Kategorie hinzufügen',

  'settings.timezone.searchPlaceholder': 'Zeitzonen durchsuchen…',
  'settings.timezone.empty': 'Keine Zeitzone gefunden.',
  'settings.timezone.useDetected': 'Erkannt: {zone} — diese verwenden',
};
